import { useEffect, useState } from "react";

// New-tab landing for backdoor login. Reads the impersonation token from the URL
// hash (never sent to the server), stores it in this tab's sessionStorage only,
// strips the hash, and enters the control plane as the target account.
//
// Must land on /dashboard — "/" is the public marketing Landing (RootGate), so
// redirecting there looks like "backdoor login failed" even with a valid token.
//
// openImpersonation() opens this route first (same-origin, user-gesture popup),
// then navigates to #t=… after the API returns. While waiting, stay here — do
// not bounce to /login or the race loses the tab.
function readTokenFromHash() {
  const hash = window.location.hash || "";
  const m = hash.match(/t=([^&]+)/);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return m[1];
  }
}

export default function ImpersonateLanding() {
  const [status, setStatus] = useState("Opening account…");

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const apply = (token) => {
      sessionStorage.setItem("wa_token", token);
      // Drop the secret from the address bar before entering the app.
      window.history.replaceState(null, "", "/impersonate");
      window.location.replace("/dashboard");
    };

    const tryOnce = () => {
      if (cancelled) return;
      const token = readTokenFromHash();
      if (token) {
        apply(token);
        return;
      }
      attempts += 1;
      // ~15s: covers slow impersonate API + popup navigation.
      if (attempts >= 75) {
        setStatus("Could not open account. Close this tab and try Login as again.");
        window.setTimeout(() => {
          if (!cancelled) window.location.replace("/login");
        }, 2000);
        return;
      }
      window.setTimeout(tryOnce, 200);
    };

    // Also react if the parent sets the hash after mount.
    const onHash = () => {
      const token = readTokenFromHash();
      if (token) apply(token);
    };
    window.addEventListener("hashchange", onHash);
    tryOnce();
    return () => {
      cancelled = true;
      window.removeEventListener("hashchange", onHash);
    };
  }, []);

  return (
    <div className="min-h-screen grid place-items-center text-sm text-muted-foreground" data-testid="impersonate-landing">
      {status}
    </div>
  );
}
